import React, { useMemo } from "react";
import { ECLRichTextViewer, ECLUserInfo } from "../../../../../index";
export default function CommentDelete({
   username,
   comment,
   historyList,
   sort,
   projectId,
}) {
   const date =
      new Date(comment.time).toDateString() +
      " " +
      new Date(comment.time).toLocaleTimeString();
   // Handle this for ascending and desc
   const currentIndex = historyList.findIndex(
      (item) => item.timestamp === comment.timestamp,
   );
   let prevIndex;
   if (sort === "desc") {
      prevIndex = currentIndex + 1;
   } else {
      prevIndex = currentIndex - 1;
   }
   let prevComment = historyList[prevIndex];

   const viewer = useMemo(
      () => (
         <ECLRichTextViewer
            textAsMarkdown={comment.text}
            project_id={projectId}
         />
      ),
      [comment.text],
   );

   const prevViewer = useMemo(
      () => (
         <ECLRichTextViewer
            textAsMarkdown={prevComment.text}
            project_id={projectId}
         />
      ),
      [prevComment.text],
   );

   return (
      <article className={"comment-history-item comment-delete"}>
         <div className="left">
            <ECLUserInfo user={comment.user} hideName={true}></ECLUserInfo>
         </div>
         <div className="right">
            <div className="top">
               <strong className="username">{username}</strong>
               {/* Dynamic Message Based On Comment Type */}
               <div className="comment-message">Deleted a Comment</div>
               <i className="date">{date}</i>
            </div>
            <div className="bottom">
               <div className="comment-action">
                  Comment Deleted:
                  {prevViewer}
               </div>
               <span className="text">{viewer}</span>
            </div>
         </div>
      </article>
   );
}
